import {
  Component, 
  OnDestroy, 
  OnInit
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PublicService } from './shared/services/public.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Schedule } from './shared/interfaces/schedule.model';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss']
})
export class PublicComponent implements OnInit, OnDestroy {

  private subscription!: Subscription;

  clinicName!: string;
  publicScheduleData!: Schedule;
  smallScreen!: boolean;
  schoolClinic!: boolean; 

  constructor(
    private breakpointObserver: BreakpointObserver,
    private publicService: PublicService
  ) {
    this.verifyScreenSize();
    this.subscription = new Subscription();
  }  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.publicService.onPublicScheduleData
      .pipe(filter(x => !!x))
      .subscribe(x => {
        this.publicScheduleData = x;
        this.clinicName = this.publicScheduleData.clinic?.name;
        this.schoolClinic = this.publicScheduleData.clinic?.school_clinic
      });
  }

  private verifyScreenSize() {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
  }

}
